import { render, staticRenderFns } from "./CompanyName.vue?vue&type=template&id=caf2b4aa&scoped=true&"
import script from "./CompanyName.vue?vue&type=script&lang=js&"
export * from "./CompanyName.vue?vue&type=script&lang=js&"
import style0 from "./CompanyName.vue?vue&type=style&index=0&id=caf2b4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf2b4aa",
  null
  
)

export default component.exports